<template>
  <v-expand-transition>
    <div v-if="saveable">
      <AppBtn :loading="saving" prepend-icon="mdi:floppy" size="small" rounded @click="save">
        {{ $tt('save_form') }}
      </AppBtn>
    </div>
  </v-expand-transition>

  <SaveFormDialog
    v-model="modalOpen"
    :email="form.client.email"
    :token :url :send-loading
    @send="send"
  />
</template>

<script setup lang="ts">
import { snackbarInjectionKey } from '~/assets/injection-keys';
import type { VisaForm } from '~/types';
import { buildResumeFormPath } from '~/helpers/routing';
import { sendResumeUrl } from '~/helpers/http';

const snackbar = inject(snackbarInjectionKey)!;

const props = defineProps<{
  form: VisaForm;
}>();

const { buildUrl } = useRouting();
const { saveable, save: _save, saving } = useFormSave(props.form);

const token = ref('');
const modalOpen = ref(false);
const sendLoading = ref(false);

const url = computed(() => {
  if (!token.value) return '';
  const path = buildResumeFormPath(props.form.country, token.value);
  return buildUrl(path);
});

async function save() {
  const data = await _save();
  token.value = data.token;
  modalOpen.value = true;
}

async function send() {
  sendLoading.value = true;
  const payload = { email: props.form.client.email, url: url.value, formId: props.form.id };
  try {
    await sendResumeUrl(payload);
  } catch (e) {
    return snackbar.value!.showError();
  } finally {
    sendLoading.value = false;
  }
  modalOpen.value = false;
  snackbar.value!.showSuccess('link_sent');
}
</script>